import ApproveRejectRightsRequest from "./ApproveRejectRightsRequest"

export default ApproveRejectRightsRequest
